#import "./UserDetails.graphql"
query UserQuery {
  user {
    ...userDetails
  }
}
